/* eslint-disable */
/**
 * THIS CODE IS AUTOMATICALLY GENERATED by @geenius/db codegen.
 *
 * Template version: 1.34-r2
 * Generated at: 2026-04-13
 * Convex SDK: ^1.34.0
 *
 * DO NOT EDIT THIS FILE MANUALLY.
 * To regenerate, run: geenius-convex-codegen
 * @module
 */

import {
  actionGeneric,
  httpActionGeneric,
  queryGeneric,
  mutationGeneric,
  internalActionGeneric,
  internalMutationGeneric,
  internalQueryGeneric,
} from "convex/server";

export const query = queryGeneric;
export const internalQuery = internalQueryGeneric;
export const mutation = mutationGeneric;
export const internalMutation = internalMutationGeneric;
export const action = actionGeneric;
export const internalAction = internalActionGeneric;
export const httpAction = httpActionGeneric;
